import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './containers/App';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from './redux/store';
import { KlokThemeProvider } from './theme/KlokThemeProvider';
import './assets/css/switzer.css'
import './assets/tailwind.css'
import './assets/style.css'
import "bootstrap-icons/font/bootstrap-icons.css";
import './assets/klok-theme.css'
import './assets/responsive.css'

store.subscribe(() => { store.getState() })
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <KlokThemeProvider>
    <Provider store={ store }>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </KlokThemeProvider>
);
